import axios from 'axios'
import notifService from '../../services/notifService'

export const getInstrument = async (context, pagination) => {
  let res = await axios
    .get('/cms/instrument', {
      params: pagination
    })
    .then(response => {
      context.commit('getInstrument', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const listInstrument = async context => {
  let res = await axios
    .get('/cms/instrument/lists')
    .then(response => {
      context.commit('listInstrument', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addInstrument = async (_context, val) => {
  let res = await axios
    .post('/cms/instrument/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const editInstrument = async (_context, val) => {
  let res = await axios
    .put('/cms/instrument/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const deleteInstrument = async (_context, val) => {
  return await axios
    .delete('/cms/instrument/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const instrumentForm = (context, val) => {
  context.commit('instrumentForm', val)
}
